'use strict';

import { lockScroll, unlockScroll } from '../util/common';

var throttle = require('lodash/throttle');

class Menu {
    constructor () {
        this.$headerTab = $('.js-menu-header-tab');
    }

    init () {
        const self = this;

        this.initSingleEvents();
        this.setupAccordion();

        $(document).on('click', '.js-menu-back', function (e) {
            $('.menu-header-container').attr('data-menu-level', $(this).attr('data-menu-previous-level'));
            if ($(this).attr('data-menu-previous-level') === '2') {
                // Going back from level 3 to 2: reset aria-expanded on the active third-level link
                $('.menu-header.active .tab-submenu.active .dropdown-item.active .dropdown-link[aria-expanded]').attr('aria-expanded', 'false');
                // wait for css transition to finish, which takes 0.4s
                setTimeout(function () {
                    $('.menu-header.active .tab-submenu.active .dropdown-item.active').removeClass('active');
                    $('.menu-header.active .tab-subsubmenu.active').removeClass('active');
                }, 400);
            } else {
                // Going back from level 2 to 1: reset aria-expanded on the active second-level link
                $('.menu-header.active .tab-menu.active .tab-name[aria-expanded]').attr('aria-expanded', 'false');
                // wait for css transition to finish, which takes 0.4s
                setTimeout(function () {
                    $('.menu-header.active .tab-menu.active').removeClass('active');
                    $('.menu-header.active .tab-submenu.active').removeClass('active');
                }, 400);
            }
        });

        $('.world-menu-opener').on('click', function (e) {
            $('.world-menu').removeClass('hidden');
        });

        $('.world-menu-closer').on('click', function (e) {
            $('.world-menu').addClass('hidden');
        });

        $('.menu-top-level.shallow').on('scroll', (e) => {
            if (!Foundation.MediaQuery.atLeast('large')) {
                this.addScrollXToMenu();
            }
        });

        $(document).on('click', '.navbar-toggler, .menu-top-level:not(.shallow) .js-menu-tab', function (e) {
            e.preventDefault(); // For some reason, the page scrolls to the top, when this is not present. At the moment, I am unaware why.
            self.addScrollXToMenu();
            self.addFocusOnMenuItem();

            $('.main-header--tezenis').addClass('open');
            lockScroll();

            // .menu-top-level:not(.shallow) .js-menu-tab
            if (Foundation.MediaQuery.atLeast('large')) {
                let $js_menu_tab = $(this);
                let target = $js_menu_tab.attr('data-menu-top-level-category-id');    

                $('.menu-header-container .menu-top-level.shallow .top-category[data-menu-top-level-category-id="' + target + '"]').addClass('active');
                $('.menu-header[data-menu-top-level-category-id="' + target + '"]').addClass('active');
                self.addFocusOnMenuItem();

            // .navbar-toggler
            } else {
                if ($('.layer-login-modal').length) {
                    $('.layer-login-modal .close-button').trigger('click');
                }

                $('.menu-header-container .menu-top-level.shallow .top-category').first().addClass('active');
                $('.menu-header').first().addClass('active');
            }

            $('.menu-header-container').attr('data-menu-state', 'opened');
            $('.menu-header-container').attr('data-menu-level', '1');
        });

        $(document).on('touchstart, click', '.js-close-button', (e) => {
            this.closeMenu();
        });

        $(document).on('mouseenter', '.overlay-menu-desktop', (e) => {
            this.closeMenu();
        });

        $(document).on('click', '.menu-top-level.shallow .js-menu-tab:not(.active)', function (e) {
            e.preventDefault();
            $('.menu-header-container').attr('data-menu-checking-highlighted-categories', 'false');
            
            self.partiallyResetMenuStates();

            $('.menu-header.active').removeClass('active');

            $('.menu-top-level.shallow .js-menu-tab.active').removeClass('active');

            const $js_menu_tab = $(this);
            $js_menu_tab.addClass('active');

            const target = $js_menu_tab.attr('data-menu-top-level-category-id');
            $('.menu-header[data-menu-top-level-category-id="' + target + '"]').addClass('active');

            $('.menu-header-container').attr('data-menu-level', '1');

            if (!Foundation.MediaQuery.atLeast('large')) {
                $('.menu-header-container .menu-top').scrollTop(0);
            }
        });

        this.animateHeaderOnScroll();
    }

    animateHeaderOnScroll () {
        var $mainHeader = $('.js-mainHeader');
        var $tezenisNav = $('.navigation--tezenis');
        var isHome = $('.js-page-home-cm').length > 0 || $('.loyalty-landing').length > 0;

        if (isHome) {
            var headerHeight = $mainHeader.outerHeight();
            var scrollTop = $(window).scrollTop();
            var addSolid = scrollTop > headerHeight;

            $mainHeader.toggleClass('cc-solid', addSolid);
            $tezenisNav.toggleClass('cc-solid', addSolid);

            $(document).on('scroll', throttle(function () {
                var scrollTop = $(window).scrollTop();
                var addSolid = scrollTop > headerHeight;

                $mainHeader.toggleClass('cc-solid', addSolid);
                $tezenisNav.toggleClass('cc-solid', addSolid);
            }, 100)); // throttle scroll handling to every 100ms
        } else {
            $mainHeader.addClass('cc-solid');
            $tezenisNav.addClass('cc-solid');
        }
    }

    initSingleEvents () {

        this.$headerTab.find('.js-open-tab-submenu').on('click', function (e) {
            if ($(this).attr('data-menu-direct-access') === 'false') {
                e.preventDefault();

                // Reset aria-expanded on the previously active second-level link
                $(this).closest('.menu-header.active').find('.tab-menu.active .tab-name[aria-expanded]').attr('aria-expanded', 'false');

                $(this).closest('.menu-header.active').find('.tab-subsubmenu.active').removeClass('active');
                $(this).closest('.menu-header.active').find('.tab-submenu.active .dropdown-item.active').removeClass('active');
                $(this).closest('.menu-header.active').find('.tab-submenu.active').removeClass('active');
                $(this).closest('.menu-header.active').find('.tab-menu.active').removeClass('active');

                if (Foundation.MediaQuery.atLeast('large')) {
                    $(this).closest('.menu-header.active').find('.tabs-submenu').removeAttr('style');
                    $(this).closest('.menu-header.active').find('.tabs-subsubmenu').removeAttr('style');
                    $(this).closest('.menu-header.active').find('.tabs-subsubmenu-background').removeAttr('style');

                    if ($(this).parent().hasClass('highlight')) {
                        $('.menu-header-container').attr('data-menu-checking-highlighted-categories', 'true');
                        $(this).closest('.menu-header.active').find('.tabs-submenu').css('marginTop', $(this).position().top + 'px');
                        $(this).closest('.menu-header.active').find('.tabs-subsubmenu').css('marginTop', $(this).position().top + 'px');
                    } else {
                        $('.menu-header-container').attr('data-menu-checking-highlighted-categories', 'false');
                    }
                }

                $(this).addClass('active');
                // Mark this second-level link as expanded
                $(this).find('.tab-name[aria-expanded]').attr('aria-expanded', 'true');

                const target = $(this).attr('data-menu-second-level-category-id');
                const $activeSubmenu = $(this).closest('.menu-header.active').find('.tab-submenu[data-menu-second-level-category-id="' + target + '"]');
                $activeSubmenu.addClass('active');

                // used by css transition
                if (Foundation.MediaQuery.atLeast('large')) {
                    $(this).closest('.menu-header.active').find('.tabs-submenu').css('width', $activeSubmenu.width() + 32 + 'px');
                }

                $('.menu-header-container').attr('data-menu-level', '2');

                if (!Foundation.MediaQuery.atLeast('large')) {
                    $('.menu-header-container .menu-top').scrollTop(0);
                }

                // Move focus to first interactive element in the newly opened third-level panel (desktop only).
                // On mobile, calling focus() interferes with CSS slide transitions causing blank screens.
                // Timeout is needed to let the CSS visibility transition complete before focusing,
                // as browsers ignore focus calls on elements that are not yet visible.
                if (Foundation.MediaQuery.atLeast('large')) {
                    const $firstFocusableElement = $activeSubmenu.find('a[href], button').first();
                    if ($firstFocusableElement.length) {
                        setTimeout(function () { $firstFocusableElement[0].focus(); }, 50);
                    }
                }
            }
        });

        this.$headerTab.find('.js-open-tab-subsubmenu').on('click', function (e) {
            if ($(this).attr('data-menu-direct-access') === 'false') {
                e.preventDefault();

                // Reset aria-expanded on the previously active third-level link
                $(this).closest('.tab-submenu.active').find('.dropdown-item.active .dropdown-link[aria-expanded]').attr('aria-expanded', 'false');

                $(this).siblings('.active').removeClass('active');
                $(this).addClass('active');
                // Mark this third-level link as expanded
                $(this).find('.dropdown-link[aria-expanded]').attr('aria-expanded', 'true');

                $(this).closest('.menu-header.active').find('.tab-subsubmenu.active').removeClass('active');

                const target = $(this).attr('data-menu-third-level-category-id');
                const $activeSubsubmenu = $(this).closest('.menu-header.active').find('.tab-subsubmenu[data-menu-third-level-category-id="' + target + '"]');
                $activeSubsubmenu.addClass('active');

                // used by css transition
                if (Foundation.MediaQuery.atLeast('large')) {
                    $(this).closest('.menu-header.active').find('.tabs-subsubmenu').css('width', $activeSubsubmenu.width() + 64 + 'px');
                    $(this).closest('.menu-header.active').find('.tabs-subsubmenu-background').css('width', $activeSubsubmenu.width() + 64 + 'px');
                }

                $('.menu-header-container').attr('data-menu-level', '3');

                if (!Foundation.MediaQuery.atLeast('large')) {
                    $('.menu-header-container .menu-top').scrollTop(0);
                }

                // Move focus to first interactive element in the newly opened fourth-level panel (desktop only).
                // On mobile, calling focus() interferes with CSS slide transitions causing blank screens.
                // Timeout is needed to let the CSS visibility transition complete before focusing,
                // as browsers ignore focus calls on elements that are not yet visible.
                if (Foundation.MediaQuery.atLeast('large')) {
                    const $firstFocusableElement = $activeSubsubmenu.find('a[href], button').first();
                    if ($firstFocusableElement.length) {
                        setTimeout(function () { $firstFocusableElement[0].focus(); }, 50);
                    }
                }
            }
        });
    }

    setupAccordion () {
        this.accordionElement = $('.accordion');
        this.accordionElement.find('.accordion-item.active .accordion-content').show();
    }

    closeMenu () {
        $('.menu-header-container').attr('data-menu-state', 'closed');
        $('.menu-header-container').attr('data-menu-level', '0');
        $('.menu-header-container').attr('data-menu-checking-highlighted-categories', 'false');

        // Reset all aria-expanded states
        this.$headerTab.find('.tab-name[aria-expanded]').attr('aria-expanded', 'false');
        this.$headerTab.find('.dropdown-link[aria-expanded]').attr('aria-expanded', 'false');

        // wait for css transition to finish, which takes 0.4s
        setTimeout(function () {
            $('.menu-header-container .menu-top-level.shallow .top-category.active').removeClass('active');
            $('.menu-header.active').removeClass('active');
            $('.main-header--tezenis').removeClass('open');
            unlockScroll();
        }, 400);

        this.partiallyResetMenuStates();
    }

    addScrollXToMenu () {
        const $menu = $('.menu-top-level.shallow');
        const el = $menu[0];
        if (!el) return;

        const scrollLeft = el.scrollLeft;
        const scrollWidth = el.scrollWidth;
        const clientWidth = el.clientWidth;

        const pixel = 1;
        let className = '';

        if (scrollWidth <= clientWidth + pixel) {
            className = '';
        } else if (scrollLeft + clientWidth >= scrollWidth - pixel) {
            className = 'mask-container-left';
        } else if (scrollLeft <= pixel) {
            className = 'mask-container';
        } else {
            className = 'mask-container-both';
        }

        $menu.removeClass('mask-container-left mask-container mask-container-both').addClass(className);
    }

    addFocusOnMenuItem () {
        const $menu = $('.menu-top-level.shallow');
        const $activeTab = $menu.find('.js-menu-tab');
        const el = $menu[0];
        if (!el) return;
        const clientWidth = el.clientWidth;
        const buffer = 5;

        $activeTab.on('click', function () {
            const tabOffsetLeft = $(this).position().left;
            const tabWidth = $(this).outerWidth();

            if (tabOffsetLeft < 0) {
                el.scrollBy({ left: tabOffsetLeft - buffer, behavior: 'smooth' });
            } else if (tabOffsetLeft + tabWidth > clientWidth) {
                const scrollAmount = (tabOffsetLeft + tabWidth + buffer) - clientWidth;
                el.scrollBy({ left: scrollAmount, behavior: 'smooth' });
            }
        });
    }

    partiallyResetMenuStates () {
        $('.menu-header.active .tabs-submenu').removeAttr('style');
        $('.menu-header.active .tabs-subsubmenu').removeAttr('style');
        $('.menu-header.active .tabs-subsubmenu-background').removeAttr('style');

        $('.menu-header.active .tab-menu.active').removeClass('active');
        $('.menu-header.active .tab-submenu.active .dropdown-item.active').removeClass('active');
        $('.menu-header.active .tab-submenu.active').removeClass('active');
        $('.menu-header.active .tab-subsubmenu.active').removeClass('active');
    }
}
const mainMenu = new Menu();
export default mainMenu;
